import $ from "jquery";
import hljs from "highlight.js/lib"

export class ApiExplorer {

	static GET_API_TOKEN_STEP = 1;
	static GET_EVENT_LIST_STEP = 2;
	static GET_PERFORMER_LIST_STEP = 3;
	static FILTER_PERFORMERS_STEP = 4;
	static GET_FIRST_WORKING_DAY_STEP = 5;
	static GET_WORK_CALENDAR_STEP = 6;
	static GET_START_TIME_MATRIX_STEP = 7;
	static CHECK_IF_ADDITIONAL_FIELDS_ACTIVE_STEP = 8;
	static GET_ADDITIONAL_FIELDS_STEP = 9;
	static PERFORM_BOOKING_STEP = 10;
	static SUMMARY_STEP = 11;

	options = {
		'url': '//user-api.simplybook.me',
		'offsetForSteps': 80
	};

	token = '';
	templates = {};
	companyLogin = '';
	codeData = {
		client : null,
		services : null,
		performers : null,
		performerId : null,
		serviceId : null,
		firstWorkingDay : null,
		additionalFieldsActivated : null,
		startDate : null,
		startDateJs : null,
		startTime : null,
	};


	postHeadersTemplate = '' +
		'POST {url} HTTP/1.1\n' +
		'Host: {host}\n' +
		'Content-Type: application/json; charset=UTF-8\n' +
		'Content-Length: {length}\n' +
		'Accept: application/json\n\n';
	postHeadersCompanyTemplate = '' +
		'POST {url} HTTP/1.1\n' +
		'Host: {host}\n' +
		'Content-Type: application/json; charset=UTF-8\n' +
		'Content-Length: {length}\n' +
		'X-Company-Login: {login}\n' +
		'X-Token: {token}\n' +
		'Accept: application/json\n\n';

	constructor(options) {
		this.options = $.extend({}, this.options, options);
		this.init();
	};

	init() {
		$('.step').hide();
		$('#step' + ApiExplorer.SUMMARY_STEP + ' .button').hide();
		$('#step' + ApiExplorer.GET_API_TOKEN_STEP).show();
		$('.right-side textarea').val('');
		this.handleFirstStep();
		this.initBreadcrumbs();
		this.initChangeVal()
	};

	initChangeVal(){
		var _this = this;
		if ($(window).width() < 768) {
			_this.options.offsetForSteps = 70;
		}
		else {
			_this.options.offsetForSteps = 80;
		}

		$(window).resize(function() {
			if ($(window).width() < 768) {
				_this.options.offsetForSteps = 70;
			}
			else {
				_this.options.offsetForSteps = 80;
			}
		});
	};

	handleFirstStep() {
		var instance = this;
		$('.step .submit').click(function () {
			instance.startCode($(this).closest('.step').data('step'));
		});
		$('.step .next-step-button').click(function () {
			instance.moveNext($(this).closest('.step').data('step'));
		});
		$('.step .method-params-container input').change(function () {
			instance.replaceParams($(this).closest('.step').data('step'));
		}).change();
	};

	replaceParams(stepId) {
		let $steUi = $('#step' + stepId + ' .code');
		if (!this.templates[stepId]) {
			this.templates[stepId] = $steUi.val();
		}
		var code = this.templates[stepId];
		var params = $('#step' + stepId + ' .method-params-container input').each(function () {
			var attr = $(this).attr('id');
			var val = $(this).val();

			code = code.replace('{' + attr + '}', val);
		});

		code = code.replace('{token}', this.token);
		code = code.replace('{companyLogin}', this.companyLogin);
		$steUi.val(code);
	};

	startCode(stepId) {
		var code = $('#step' + stepId + ' .code').val();
		if(code){
			//code = JSON.parse(code);
		}
		code = code.replace('JSONRpcClient', 'ApiExplorerClient');
		code = this._replaceAll(code,'jQuery', '$');
		//code = code.replace('var ', 'ApiExplorerClient.');

		try {
			switch (stepId) {
				case ApiExplorer.GET_FIRST_WORKING_DAY_STEP:
					if (!$('#select_event_id').val() || !$('#select_unit_id').val()) {
						alert('Please select service and provider to continue.');
						return;
					} else {
						this.codeData.performerId = $('#select_unit_id').val();
						this.codeData.serviceId = $('#select_event_id').val();
					}
					break;
			}

			if (this.codeData.startDateJs) {
				this.codeData.startDate = this.codeData.startDateJs.getFullYear() + '-' + ("0" + (this.codeData.startDateJs.getMonth() + 1)).slice(-2) + '-' + ("0" + this.codeData.startDateJs.getDate()).slice(-2);
			} else {
				this.codeData.startDate = null;
			}

			jQuery.each(this.codeData, function (key, val) {
				window[key] = val;
			});

			window.eval(code);
		} catch (e) {
			console.log(code);
			console.log(e);
			alert('Error! Please check code. (' + e + ')');
		}

		var updateInfoArea = true;
		var result = null;

		switch (stepId) {
			case ApiExplorer.GET_API_TOKEN_STEP:
				this.codeData.client = window.loginClient;
				result = window.token;
				this.token = window.token;
				this.companyLogin = $('#companyLogin').val();
				break;

			case ApiExplorer.GET_EVENT_LIST_STEP:
				this.codeData.client = window.client;
				this.codeData.services = window.services;
				result = window.services;

				break;
			case ApiExplorer.GET_PERFORMER_LIST_STEP:
				result = window.performers;
				this.codeData.performers = window.performers;

				break;
			case ApiExplorer.GET_FIRST_WORKING_DAY_STEP:
				this.codeData.serviceId = $('#select_event_id').val();
				this.codeData.performerId = $('#select_unit_id').val();
				this.codeData.firstWorkingDay = window.firstWorkingDay;

				result = window.firstWorkingDay;

				break;
			case ApiExplorer.GET_WORK_CALENDAR_STEP:
				result = window.workCalendar;

				break;
			case ApiExplorer.GET_START_TIME_MATRIX_STEP:
				result = window.startMatrix;
				break;

			case ApiExplorer.CHECK_IF_ADDITIONAL_FIELDS_ACTIVE_STEP:
				this.codeData.additionalFieldsActivated = window.additionalFieldsActivated;
				result = window.additionalFieldsActivated;
				break;

			case ApiExplorer.GET_ADDITIONAL_FIELDS_STEP:
				if (!this.codeData.additionalFieldsActivated) {
					updateInfoArea = false;
				} else {
					result = window.additionalFields;
				}
				break;
			case ApiExplorer.PERFORM_BOOKING_STEP:
				result = window.result;
				break;
			default:
				break;
		}

		if (updateInfoArea) {
			this.updateStepInfo(stepId, this.codeData.client, result);
		}
		var instance = this;

		if (stepId === ApiExplorer.GET_API_TOKEN_STEP) {
			// replace token and company login in all steps

			$('.step').each(function () {
				if ($(this).data('step') != ApiExplorer.GET_API_TOKEN_STEP && $(this).data('step') != ApiExplorer.SUMMARY_STEP) {
					instance.replaceParams($(this).data('step'));
				}
			});
		}

		if (this.codeData.client && this.codeData.client.isSuccessLastRequest()) {
			// in ApiExplorer.GET_START_TIME_MATRIX_STEP step we should click date and time first
			if (stepId !== ApiExplorer.GET_START_TIME_MATRIX_STEP) {
				instance.beforeMoveNext(stepId);
			} else {
				$('#starttime span').click(function () {
					instance.beforeMoveNext(stepId);
				});
			}
		}
	};

	beforeMoveNext(stepId) {
		$('#step' + stepId + ' .next-step-button').addClass('active');
		//console.log( 'beforeMoveNext(stepId)' )
		$('html, body').animate({
			scrollTop: $('#step' + stepId + ' .buttons-container').offset().top - this.options.offsetForSteps
		}, 1000);
	};

	moveNext(stepId) {
		switch (stepId) {
			case this.FILTER_PERFORMERS_STEP:
				$('#select_event_id').val($('#select_event_id option:nth-child(2)').val());
				$('#select_unit_id').val($('#select_unit_id option:nth-child(2)').val());
				break;

			case ApiExplorer.GET_START_TIME_MATRIX_STEP:
				this.codeData.startDateJs = $('#datepicker').datepicker('getDate');
				this.codeData.startTime = $('#starttime .selected').data('time');
				if (!this.codeData.startDateJs  || !this.codeData.startTime) {
					alert('Select start date and time to continue.');
					return;
				}
		}
		this.showNextStep(parseInt(stepId) + 1);
	};

	updateStepInfo(stepId, client, result) {
		var headersTemplate = this.postHeadersCompanyTemplate;
		if (stepId === ApiExplorer.GET_API_TOKEN_STEP) {
			headersTemplate = this.postHeadersTemplate;
		}

		var templateVars = {
			'login': this.companyLogin,
			'token': this.token,
			'length': client.getLastRequest().length,
			'host': this.getParam('url').replace('//', ''),
			'url': client.getParam('url').replace(this.getParam('url'), '')
		};

		for (var v in templateVars) {
			headersTemplate = headersTemplate.replace('{' + v + '}', templateVars[v]);
		}
		//console.log(result);

		$('#step' + stepId + ' .http-request code').html(headersTemplate + client.getLastRequest()).change();
		$('#step' + stepId + ' .http-response code').html(JSON.stringify(JSON.parse(client.getLastResponse()), null, "\t")).change();
		$('#step' + stepId + ' .json-response code').html(JSON.stringify(result, null, "\t")).change();

		this._updateEditorView();
	};

	_updateEditorView(){
		hljs.initHighlighting.called = false;
		hljs.initHighlighting();
	};

	showNextStep(stepId) {
		var step = $('#step' + stepId);
		if (step.length) {
			step.show();
			//console.log( 'showNextStep(stepId)' )
			$('html, body').animate({
				scrollTop: step.offset().top - this.options.offsetForSteps
			}, 1000);
		}
	};

	getParam(param, defaultValue) {
		if (typeof (this.options[param]) != 'undefined') {
			return this.options[param];
		}
		return defaultValue;
	};

	initBreadcrumbs() {
		var instance = this;
		$('.step-headers-container .step-headers li').click(function () {
			instance.showNextStep($(this).data('step-id'));
		});
	};

	_replaceAll(str, find, replace) {
		return str.replace(new RegExp(find, 'g'), replace);
	};
}

